import { CSSProperties, SxProps, Theme } from '@mui/material';
import { atlasSemantic } from 'src/theme/atlas/tokens';
import styled from 'styled-components';

export const PageContentBox = styled.div`
  /* RoutingBody (this page's parent) already sets height:100%/overflow:auto;
     nesting the same here double-scrolls and pagination stays unreachable. */
  height: auto;
  overflow: visible;
  display: flex;
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.default};
  padding: ${(props) => props.theme.atlas.core.spacing[3]}
    ${(props) => props.theme.atlas.core.spacing[6]};
  gap: ${(props) => props.theme.atlas.core.spacing[4]};
  flex-direction: column;
`;

// Hardcoded to match Figma exactly (node #I16403:36220;35634:2205) — no
// matching semantic token for this light-tint selected state.
const TOGGLE_SELECTED_FILL = '#ECF0FF';
const TOGGLE_SELECTED_TEXT = '#0040D5';
const TOGGLE_UNSELECTED_TEXT = '#232429';
const TOGGLE_UNSELECTED_BORDER = '#888B9A';

export const toggleGroup: SxProps<Theme> = {
  '& .MuiToggleButtonGroup-grouped': {
    border: `1px solid ${TOGGLE_UNSELECTED_BORDER}`,
    margin: 0,
    textTransform: 'none',
    color: TOGGLE_UNSELECTED_TEXT,
  },
  '& .MuiToggleButtonGroup-grouped:not(:first-of-type)': {
    borderLeftColor: 'transparent',
  },
  '& .MuiToggleButton-root.Mui-selected': {
    backgroundColor: TOGGLE_SELECTED_FILL,
    color: TOGGLE_SELECTED_TEXT,
    borderColor: TOGGLE_SELECTED_TEXT,
  },
  '& .MuiToggleButton-root.Mui-selected:hover': {
    backgroundColor: TOGGLE_SELECTED_FILL,
    color: TOGGLE_SELECTED_TEXT,
  },
};

export const filterButton: CSSProperties = {
  backgroundColor: atlasSemantic.color.action.secondary.hoverFill,
  border: 'none',
  color: atlasSemantic.color.type.default,
  fontWeight: 600,
};
